interface TooltipMedicoesInput {
  readOnly: boolean
  hasMedicoes: boolean
  showMedicoesAnteriores: boolean
}

export function getTooltipMedicoes(input: TooltipMedicoesInput): string {
  const { readOnly, hasMedicoes, showMedicoesAnteriores } = input

  if (hasMedicoes) return readOnly ? 'Ver medições' : 'Ver ou adicionar medições'
  if (readOnly) return showMedicoesAnteriores ? 'Nenhuma medição registrada' : 'Nenhuma medição registrada hoje'
  return 'Adicionar medições anteriores'
}
